import { C } from '../theme';
import type { CriticalDateRow, LedgerStatus, TenancyRow } from '../api';
import type { PillKind } from '../components/Pill';

/** "Showroom · ground" from a roster/tenancy row. */
export function unitDesc(row: { unitKind?: string; floor?: string | null }): string {
  const kind = row.unitKind ? cap(row.unitKind) : '';
  const floor = row.floor ? row.floor.toLowerCase() : '';
  return [kind, floor].filter(Boolean).join(' · ');
}

export function cap(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** Accent bar colour for a date-radar row. */
export function dateBarColor(d: CriticalDateRow): string {
  if (d.overdue) return C.red;
  if (d.type === 'escalation') return C.hi;
  return C.accent;
}

/** The big number + unit shown at the left of a date-radar row. */
export function dateCount(d: CriticalDateRow): { n: string; unit: string; red: boolean } {
  const days = d.dueInDays;
  if (days == null) return { n: '–', unit: '', red: false };
  if (days < 0) return { n: String(Math.abs(days)), unit: `${Math.abs(days) === 1 ? 'day' : 'days'} over`, red: true };
  if (days === 0) return { n: 'today', unit: '', red: true };
  return { n: String(days), unit: days === 1 ? 'day' : 'days', red: false };
}

/** Roster row status → pill kind + label, defaulting sensibly. */
export function rowPill(status: LedgerStatus | undefined, dueInDays?: number | null): { kind: PillKind; label: string } {
  if (status === 'paid') return { kind: 'paid', label: 'Paid' };
  if (status === 'overdue') return { kind: 'over', label: 'Overdue' };
  if (status === 'partial') return { kind: 'over', label: 'Partial' };
  if (status === 'due' && dueInDays != null && dueInDays >= 0) {
    return { kind: 'due', label: `Due ${dueInDays}d` };
  }
  if (status === 'due') return { kind: 'due', label: 'Due' };
  return { kind: 'due', label: '–' };
}

export type { TenancyRow };
